import styled from 'styled-components';
import { Typography, TypographyProps, TypographyVariant } from '@material-ui/core';
import * as React from 'react';
import { theme } from '../../utils/theme';
import { Skeleton } from '@material-ui/lab';

export type H2Props = TypographyProps & {
  variant?: TypographyVariant;
}

export const StyledH2 = styled(Typography)((props) => ({
  color: theme(props).palette.common.black,
  opacity: 0.5,
  fontSize: "14px",
  marginTop: "3px",
  textAlign: "left",
  fontWeight: "bold",
  lineHeight: "17px",
})) as typeof Typography;

export const H2: React.FC<H2Props> = props => {
  if (props.children) {
    return (<StyledH2 variant="h2" align="left" display="block" noWrap {...props} />);
  }
  return <Skeleton variant="rect" width="35%" height="29px" />;
}